import React from 'react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ContactForm from '../components/contact-form'
import NewsletterSubscribe from '../components/newsletter-subscribe'
import Footer from '../components/footer'

import './kontakt.css'

const Kontakt = () => {
  return (
    <div className="kontakt-container">
      <Helmet>
        <title>Kontakt</title>
      </Helmet>

      <Navigation />

      {/* Kontaktformular */}
      <ContactForm />

      {/* Newsletter */}
      <NewsletterSubscribe />

      <Footer />
    </div>
  )
}

export default Kontakt
